var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-bg"},[_c('div',{staticClass:"loadingP"},[_c('van-loading',{attrs:{"type":"spinner","vertical":"","color":"#ff9922"}},[_c('p',{staticStyle:{"color":"#ff9922"}},[_vm._v("页面正在加载中…")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }